<template>
  <div class="section">
    <!-- 团队适配 -->
    <div class="title-info">
      个体具有相对合作性的团体中所占据的具有自身特色与功能性的角色定位。
    </div>
    <div class="tuan-detail">
      <TuanDetail
        :result="result"
        :detail="detail"
        :maxScore="maxScore"
        :minScore="minScore"
        :maxName="maxName"
        :title="title"
        :IsTeamZero="IsTeamZero"
      />
    </div>
    <div class="result-title">
      典型团队角色：
      <span
        class="result-content"
        v-if="this.maxScore != 0 && this.isMoreTop == false"
      >
        {{ this.maxName }}
      </span>
      <span
        class="result-content"
        v-if="this.maxScore == 0 || this.isMoreTop == true"
      >
        无
      </span>
    </div>
    <div class="advice-info">
      <div class="advice-info-title">
        <img :src="images.icR" style="width: 2.5%" />
        <span>面试建议</span>
      </div>
      <div style="padding-left: 30px; padding-top: 20px" v-if="this.advice2.length != 0 || this.advice != undefined">
        问题仅供参考，面试官可结合现场实况进行灵活调整。
      </div>
      <!-- <ul>
      <li style="color:#2ABCB9"><span style="color:black"> 不论从事什么样的工作都会有重复性的、比较单调沉闷的部分，你是如何处理这些工作的？</span></li>
      <li style="color:#2ABCB9"><span style="color:black"> 有时候会出现这样的情况，尽管当时你已经很忙了，但还有一项更重要的工作需要你来做，你会怎么处理？</span></li>
      </ul> -->

      <!-- 认知模块面试建议 -->
      <div v-if="this.advice && this.isPerReport == true">
        <div
          v-for="(item, index) in this.advice"
          :key="index"
          style="padding: 7px 30px 0 30px"
        >
          <div>
            <img :src="images.ic" style="height: auto; width: 0.7%" />
            {{ item.name }}
          </div>
          <div
            style="margin-left: -10px; font-size: 14px"
            v-html="item.define"
          ></div>
        </div>
      </div>
      <!-- 人格模块面试建议  -->
      <!-- <div v-if="this.advice2.length != 0"> -->
      <div
        v-for="(item, index) in this.advice2"
        :key="index"
        style="padding: 7px 30px 0 30px"
      >
        <div>
          <img :src="images.ic" style="height: auto; width: 0.7%" />
          {{ item.name }}
        </div>
        <div
          style="margin-left: -10px; font-size: 14px"
          v-html="item.define"
        ></div>
      </div>

<!-- <br/>
{{advice2}} -->
      <div v-if="this.advice2.length == 0 && this.advice == undefined" style="padding: 20px 30px 0 30px;text-align: center">
          被测者无明显信息确认，面试官可结合岗位要求自行补充说明。

      </div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import TuanDetail from "@/components/dataView/table/all/TuanDetail.vue";
export default {
  props: ["result", "advice", "advice2", "IsTeamZero", "isPerReport"],
  components: { TuanDetail },
  data() {
    return {
      detail: [],
      max: [],
      isMoreTop: false,
      maxScore: 0,
      minScore: 0,
      maxName: "",
      count: 0,
      min: [],
      images: {
        ic: require("../../../assets/images/all/ic.png"),
        icR: require("../../../assets/images/all/icR.png"),
      },
      title: [
        "实干者",
        "协调者",
        "推进者",
        "创新者",
        "信息者",
        "监督者",
        "凝聚者",
        "完善者",
        "专家型",
      ],
    };
  },
  mounted() {
    if (this.result) {
      this.loadTitle();
    }
  },
  watch: {
    result(val) {
      this.loadTitle();
    },
  },
  methods: {
    loadTitle() {
      this.detail = [];

      this.title.map((item, index) => {
        this.detail.push({
          name: item,
          score: this.result[index],
        });
        if (this.result[index] == Math.max(...this.result)) {
          this.max.push({
            name: item,
            score: this.result[index],
           
          });
          this.maxName = item;
          this.maxScore = this.result[index];
        } else if (this.result[index] == Math.min(...this.result)) {
          this.min.push({
            name: item,
            score: this.result[index],
          });
          this.minScore = this.result[index];
        }
      });
      if (this.max.length > 3) {
        this.isMoreTop = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
  background-size: cover;
  background-image: url("../../../assets/images/all/bg55.png");
  height: 1124px;
  overflow: hidden;
  .title-info {
    padding: 270px 0 0 0;
    font-size: 14px;
    text-align: center;
  }
  .tuan-detail {
    margin-top: 50px;
    width: 80%;
    margin-left: 110px;
  }
  .advice-info {
    margin-top: 50px;

    width: 100%;
    height: 550px;
    background-color: #f5f8fd;
    .advice-info-title {
      text-align: center;
      padding-top: 20px;
      font-weight: bold;
      font-size: 25px;
    }
  }
  .result-title {
    color: white;
    font-size: 18px;
    font-weight: bold;
    padding-top: 35px;
    margin-left: 40px;
    line-height: 30px;
  }
  .result-content {
    color: white;
    font-size: 30px;
    font-weight: bold;
    padding-top: 1px;
    height: 90px;
    margin-left: -10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/report/four/pageSix.vue